export interface ComicChapter {
  id: number;
  title: string;
  number: string;
  updatedAt: string;
}

export interface Comic {
  id: number;
  title: string;
  author: string;
  coverImage: string;
  description: string;
  category: string;
  categorySlug: string;
  tags: string[];
  status: string;
  rating: number;
  views: number;
  favorites: number;
  chapters: ComicChapter[];
  updatedAt: string;
  createdAt: string;
  isHot: boolean;
  isNew: boolean;
  isCompleted: boolean;
}

export const categories = [
  { name: '全部', slug: 'all' },
  { name: '恋爱', slug: 'romance' },
  { name: '奇幻', slug: 'fantasy' },
  { name: '动作', slug: 'action' },
  { name: '搞笑', slug: 'comedy' },
  { name: '悬疑', slug: 'thriller' },
  { name: '日常', slug: 'slice-of-life' },
  { name: '剧情', slug: 'drama' },
  { name: '恐怖', slug: 'horror' },
  { name: 'BL', slug: 'bl' },
];

export const comics: Comic[] = [
  {
    id: 1,
    title: '某天成为公主',
    author: 'Plutus / Spoon',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20webtoon%20cover%20illustration%20featuring%20a%20princess%20in%20an%20elegant%20gown%20with%20long%20flowing%20hair%2C%20soft%20pastel%20colors%2C%20romantic%20fantasy%20atmosphere%2C%20watercolor%20style%2C%20painterly%20texture%2C%20dreamy%20background%20with%20castle%20silhouette%2C%20simple%20clean%20composition%20centered%20on%20single%20character%2C%20delicate%20details&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    description: '在一个魔法与剑的世界里，一位普通的现代女孩意外穿越成了小说中的公主。为了改变原著的悲惨结局，她必须运用自己的智慧在这个充满危险与浪漫的宫廷中生存下去。随着故事的发展，她发现自己越来越深陷于这个世界的阴谋与爱情之中，而她的每一个选择都将改变所有人的命运。这是一部融合了浪漫、奇幻与宫廷政治的精彩韩漫，以其精美的画风和扣人心弦的剧情赢得了无数读者的喜爱。',
    category: '恋爱',
    categorySlug: 'romance',
    tags: ['穿越', '宫廷', '浪漫', '贵族'],
    status: '连载中',
    rating: 9.6,
    views: 12500000,
    favorites: 890000,
    chapters: [
      { id: 101, title: '第125话 - 命运的选择', number: '125', updatedAt: '2026-08-04' },
      { id: 102, title: '第124话 - 月光下的誓言', number: '124', updatedAt: '2026-07-28' },
      { id: 103, title: '第123话 - 皇室舞会', number: '123', updatedAt: '2026-07-21' },
      { id: 104, title: '第122话 - 秘密花园', number: '122', updatedAt: '2026-07-14' },
      { id: 105, title: '第121话 - 父王的阴谋', number: '121', updatedAt: '2026-07-07' },
    ],
    updatedAt: '2026-08-04',
    createdAt: '2023-03-15',
    isHot: true,
    isNew: false,
    isCompleted: false,
  },
  {
    id: 2,
    title: '我独自升级',
    author: 'Chugong / DUBU',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dark%20fantasy%20Korean%20webtoon%20cover%20illustration%20of%20a%20powerful%20male%20warrior%20with%20glowing%20eyes%20and%20dark%20armor%2C%20holding%20a%20sword%2C%20dramatic%20lighting%20with%20purple%20and%20black%20tones%2C%20action%20fantasy%20genre%2C%20cinematic%20composition%2C%20intense%20atmosphere%2C%20clean%20background%2C%20simple%20product%20shot%20style&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    description: '在一个突然出现「门」与「猎人」的世界里，被称为「人类最弱兵器」的成振宇在一次几乎致命的双重地下城探险中，获得了一个神秘的系统——「玩家系统」。从此，他成为了唯一能够「升级」的猎人。从最弱到最强，成振宇踏上了成为世界最强猎人的征途。这部作品以其震撼的战斗场面、引人入胜的剧情和精美的画风，成为近年来最受欢迎的韩漫之一。',
    category: '动作',
    categorySlug: 'action',
    tags: ['升级', '战斗', '系统流', '奇幻'],
    status: '已完结',
    rating: 9.8,
    views: 45000000,
    favorites: 2100000,
    chapters: [
      { id: 201, title: '第179话 - 终章', number: '179', updatedAt: '2025-12-25' },
      { id: 202, title: '第178话 - 最后的战斗', number: '178', updatedAt: '2025-12-18' },
      { id: 203, title: '第177话 - 君主降临', number: '177', updatedAt: '2025-12-11' },
    ],
    updatedAt: '2025-12-25',
    createdAt: '2021-06-20',
    isHot: true,
    isNew: false,
    isCompleted: true,
  },
  {
    id: 3,
    title: '女神降临',
    author: 'Yaongyi',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20glamorous%20Korean%20webtoon%20cover%20illustration%20of%20a%20beautiful%20young%20woman%20with%20perfect%20makeup%20and%20stylish%20outfit%2C%20romantic%20school%20life%20setting%2C%20soft%20warm%20lighting%2C%20feminine%20pink%20and%20peach%20color%20palette%2C%20k-beauty%20aesthetic%2C%20clean%20simple%20composition%2C%20modern%20fashion%20vibe&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    description: '因为外貌而饱受欺凌的任朱静，通过化妆技巧完成了惊人的变身，成为了校园里的「女神」。但她的素颜秘密却时刻威胁着这一切。当两个截然不同的男生——高冷学霸李修豪和阳光校草韩书俊同时走进她的生活，她的世界变得更加复杂。这是一部关于美丽、自信与真爱的成长故事，以其细腻的情感描写和精致的画风俘获了全球读者的心。',
    category: '恋爱',
    categorySlug: 'romance',
    tags: ['校园', '化妆', '爱情', '成长'],
    status: '已完结',
    rating: 9.4,
    views: 38000000,
    favorites: 1800000,
    chapters: [
      { id: 301, title: '第230话 - 永远的女神', number: '230', updatedAt: '2025-08-10' },
      { id: 302, title: '第229话 - 选择', number: '229', updatedAt: '2025-08-03' },
      { id: 303, title: '第228话 - 告白', number: '228', updatedAt: '2025-07-27' },
    ],
    updatedAt: '2025-08-10',
    createdAt: '2020-01-10',
    isHot: true,
    isNew: false,
    isCompleted: true,
  },
  {
    id: 4,
    title: '全知读者视角',
    author: 'sing N song / Sleepy-C',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20mysterious%20Korean%20webtoon%20cover%20illustration%20of%20a%20male%20protagonist%20with%20glasses%20reading%20a%20glowing%20book%2C%20surrounded%20by%20floating%20text%20and%20apocalyptic%20cityscape%20background%2C%20fantasy%20sci-fi%20genre%2C%20cool%20blue%20and%20white%20color%20scheme%2C%20dramatic%20composition%2C%20clean%20simple%20style&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    description: '金独子是一个普通的上班族，唯一的爱好就是阅读一本连载了十年的网络小说《在灭亡的世界中存活的三种方法》。当这本小说终于完结的那一天，小说中的世界竟然变成了现实，而金独子——作为唯一一个读完了整部小说的人——成为了这个末日世界中掌握着最多信息的人。凭借对剧情的了解，他必须在这个残酷的世界中生存下去，并改变他所知道的故事结局。',
    category: '奇幻',
    categorySlug: 'fantasy',
    tags: ['末世', '系统', '读者视角', '生存'],
    status: '连载中',
    rating: 9.7,
    views: 28000000,
    favorites: 1500000,
    chapters: [
      { id: 401, title: '第210话 - 最后的篇章', number: '210', updatedAt: '2026-08-03' },
      { id: 402, title: '第209话 - 星流的尽头', number: '209', updatedAt: '2026-07-27' },
      { id: 403, title: '第208话 - 古老的盟约', number: '208', updatedAt: '2026-07-20' },
      { id: 404, title: '第207话 - 神话的终结', number: '207', updatedAt: '2026-07-13' },
    ],
    updatedAt: '2026-08-03',
    createdAt: '2022-05-10',
    isHot: true,
    isNew: false,
    isCompleted: false,
  },
  {
    id: 5,
    title: '甜蜜陷阱',
    author: 'Haejin',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20sweet%20romantic%20Korean%20webtoon%20cover%20illustration%20of%20a%20couple%20sharing%20a%20tender%20moment%20in%20a%20cozy%20cafe%2C%20warm%20amber%20lighting%2C%20soft%20romantic%20atmosphere%2C%20pastel%20warm%20colors%2C%20comfortable%20and%20intimate%20composition%2C%20clean%20simple%20background%2C%20young%20adult%20romance&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    description: '咖啡店老板姜智浩遇到了总是来店里写作的兼职小说家林素英。一杯杯精心调制的咖啡，一段段偶然的邂逅，两人在咖啡的香气中慢慢靠近。然而，当林素英发现姜智浩的真实身份竟然是业界传奇咖啡师时，一切都变得复杂起来。这是一个关于爱情、梦想与咖啡的温暖故事，画风温馨治愈，让人感受到生活中最美好的小确幸。',
    category: '恋爱',
    categorySlug: 'romance',
    tags: ['咖啡', '日常', '温馨', '治愈'],
    status: '连载中',
    rating: 9.3,
    views: 8500000,
    favorites: 620000,
    chapters: [
      { id: 501, title: '第68话 - 甜蜜的告白', number: '68', updatedAt: '2026-08-02' },
      { id: 502, title: '第67话 - 雨天的回忆', number: '67', updatedAt: '2026-07-26' },
      { id: 503, title: '第66话 - 新的配方', number: '66', updatedAt: '2026-07-19' },
    ],
    updatedAt: '2026-08-02',
    createdAt: '2024-11-01',
    isHot: false,
    isNew: true,
    isCompleted: false,
  },
  {
    id: 6,
    title: '剑尊归来',
    author: 'Cheongcho / LICO',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20martial%20arts%20Korean%20webtoon%20cover%20illustration%20of%20a%20swordsman%20in%20traditional%20hanbok%20holding%20a%20glowing%20sword%2C%20ancient%20Korean%20palace%20background%2C%20dramatic%20wind%20effect%2C%20dynamic%20action%20pose%2C%20warm%20golden%20and%20crimson%20colors%2C%20epic%20fantasy%20style%2C%20clean%20composition&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    description: '曾经被称为「天下第一剑」的柳白，在与魔教教主的最终决战中双双陨落。然而，当他再次睁开眼睛时，发现自己回到了二十年前——一切都还未开始的少年时代。带着前世的记忆与剑术造诣，他决心改变过去所有的遗憾，守护那些他曾经失去的人们。这是一部融合了武侠与穿越元素的精彩作品，战斗场面华丽震撼。',
    category: '动作',
    categorySlug: 'action',
    tags: ['武侠', '重生', '复仇', '热血'],
    status: '连载中',
    rating: 9.5,
    views: 18000000,
    favorites: 1100000,
    chapters: [
      { id: 601, title: '第142话 - 剑意巅峰', number: '142', updatedAt: '2026-08-04' },
      { id: 602, title: '第141话 - 决战前夕', number: '141', updatedAt: '2026-07-28' },
      { id: 603, title: '第140话 - 宿命的对决', number: '140', updatedAt: '2026-07-21' },
    ],
    updatedAt: '2026-08-04',
    createdAt: '2023-09-20',
    isHot: true,
    isNew: false,
    isCompleted: false,
  },
  {
    id: 7,
    title: '惊悚考试院',
    author: 'Kim Yongki',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20creepy%20thriller%20Korean%20webtoon%20cover%20illustration%20of%20a%20dark%20narrow%20hallway%20in%20a%20gosiwon%20dormitory%2C%20dim%20flickering%20light%2C%20ominous%20atmosphere%2C%20shadows%20lurking%2C%20psychological%20horror%20genre%2C%20muted%20dark%20green%20and%20gray%20tones%2C%20tense%20and%20unsettling%20composition%2C%20clean%20simple%20style&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    description: '为了准备公务员考试，尹钟宇搬进了一家便宜的考试院。然而，这个看似普通的住处却隐藏着令人毛骨悚然的秘密。奇怪的邻居、深夜传来的诡异声响、不断消失的住户——尹钟宇发现自己被困在了一场无法逃脱的噩梦中。当真相一点点浮出水面，他意识到最可怕的不是鬼怪，而是人心。这是一部让人无法呼吸的心理惊悚韩漫，每一话都充满了让人毛骨悚然的紧张感。',
    category: '悬疑',
    categorySlug: 'thriller',
    tags: ['恐怖', '心理', '悬疑', '社会'],
    status: '已完结',
    rating: 9.2,
    views: 9500000,
    favorites: 580000,
    chapters: [
      { id: 701, title: '第56话 - 真相', number: '56', updatedAt: '2025-06-15' },
      { id: 702, title: '第55话 - 最后的夜晚', number: '55', updatedAt: '2025-06-08' },
      { id: 703, title: '第54话 - 追踪', number: '54', updatedAt: '2025-06-01' },
    ],
    updatedAt: '2025-06-15',
    createdAt: '2024-03-01',
    isHot: false,
    isNew: false,
    isCompleted: true,
  },
  {
    id: 8,
    title: '社长大人是猫咪',
    author: 'Mongddang',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20cute%20comedy%20Korean%20webtoon%20cover%20illustration%20of%20a%20handsome%20CEO%20man%20with%20cat%20ears%20and%20tail%2C%20playful%20and%20funny%20expression%2C%20office%20setting%2C%20bright%20cheerful%20colors%2C%20lighthearted%20whimsical%20style%2C%20simple%20clean%20composition%2C%20comedy%20genre&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    description: '李多海好不容易找到了一份理想的工作，却发现她的直属上司——公司社长——竟然会在每个满月之夜变成一只猫！更糟糕的是，只有她一个人知道这个秘密。为了保住工作，她不得不帮助社长隐瞒这个惊天秘密，同时还要应对各种因为「猫属性」而引发的爆笑事件。这是一部让人捧腹大笑的职场搞笑漫画，轻松的剧情与可爱的画风完美结合。',
    category: '搞笑',
    categorySlug: 'comedy',
    tags: ['职场', '变身', '猫', '搞笑'],
    status: '连载中',
    rating: 9.1,
    views: 7200000,
    favorites: 490000,
    chapters: [
      { id: 801, title: '第89话 - 满月派对', number: '89', updatedAt: '2026-08-01' },
      { id: 802, title: '第88话 - 猫薄荷陷阱', number: '88', updatedAt: '2026-07-25' },
      { id: 803, title: '第87话 - 社长的秘密', number: '87', updatedAt: '2026-07-18' },
    ],
    updatedAt: '2026-08-01',
    createdAt: '2024-06-15',
    isHot: false,
    isNew: true,
    isCompleted: false,
  },
  {
    id: 9,
    title: '恶女的定义',
    author: 'Solche / NEMONE',
    coverImage: 'https://readdy.ai/api/search-image?query=An%20elegant%20dark%20romance%20Korean%20webtoon%20cover%20illustration%20of%20a%20villainess%20noblewoman%20in%20a%20luxurious%20gothic%20gown%2C%20confident%20expression%2C%20dramatic%20red%20and%20black%20color%20scheme%2C%20thorny%20rose%20motif%2C%20aristocratic%20fantasy%20setting%2C%20mature%20and%20sophisticated%20style%2C%20clean%20composition&width=600&height=800&seq=comic-cover-09&orientation=portrait',
    description: '伊芙琳·德·蒙特罗斯被世人称为「社交界的恶女」。她冷酷、算计、为了目的不择手段——至少外界是这么认为的。然而，当她意外救下了失忆的公爵继承人后，一切都开始改变。在照顾这个神秘男子的过程中，她冰封的内心开始融化，而隐藏在她冷酷外表下的真相也渐渐浮出水面。这不是一个关于恶女的故事，而是一个关于被世界误解的女人的救赎之旅。',
    category: '剧情',
    categorySlug: 'drama',
    tags: ['贵族', '反转', '爱情', '权谋'],
    status: '连载中',
    rating: 9.0,
    views: 6100000,
    favorites: 420000,
    chapters: [
      { id: 901, title: '第75话 - 面具之下', number: '75', updatedAt: '2026-08-03' },
      { id: 902, title: '第74话 - 公爵的过去', number: '74', updatedAt: '2026-07-27' },
      { id: 903, title: '第73话 - 月光华尔兹', number: '73', updatedAt: '2026-07-20' },
    ],
    updatedAt: '2026-08-03',
    createdAt: '2024-08-10',
    isHot: false,
    isNew: false,
    isCompleted: false,
  },
  {
    id: 10,
    title: '平凡的一天',
    author: 'Lee Hyeonmin',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20warm%20slice%20of%20life%20Korean%20webtoon%20cover%20illustration%20of%20a%20young%20woman%20in%20casual%20clothes%20walking%20through%20a%20peaceful%20neighborhood%2C%20cherry%20blossom%20trees%2C%20soft%20sunlight%2C%20calm%20and%20relaxing%20atmosphere%2C%20gentle%20pastel%20colors%2C%20everyday%20life%20aesthetic%2C%20clean%20simple%20composition&width=600&height=800&seq=comic-cover-10&orientation=portrait',
    description: '这是一部关于日常生活的小故事合集。每一个短篇都捕捉了生活中那些转瞬即逝的美好瞬间——街角面包店的香气、雨中偶遇的旧友、深夜里的一通电话。没有惊心动魄的剧情，没有复杂的人物关系，只有那些让我们会心一笑的生活片段。在快节奏的现代生活中，这部作品就像一个温暖的拥抱，提醒我们停下脚步，感受生活的美好。',
    category: '日常',
    categorySlug: 'slice-of-life',
    tags: ['日常', '温馨', '短篇', '治愈'],
    status: '连载中',
    rating: 9.3,
    views: 4800000,
    favorites: 350000,
    chapters: [
      { id: 1001, title: '第42话 - 雨天的面包店', number: '42', updatedAt: '2026-08-02' },
      { id: 1002, title: '第41话 - 旧书店的午后', number: '41', updatedAt: '2026-07-26' },
      { id: 1003, title: '第40话 - 深夜的便利店', number: '40', updatedAt: '2026-07-19' },
    ],
    updatedAt: '2026-08-02',
    createdAt: '2024-10-05',
    isHot: false,
    isNew: false,
    isCompleted: false,
  },
  {
    id: 11,
    title: '深渊的低语',
    author: 'DarkBear',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20horror%20Korean%20webtoon%20cover%20illustration%20of%20a%20dark%20abyss%20with%20glowing%20eyes%20staring%20from%20the%20darkness%2C%20creepy%20supernatural%20atmosphere%2C%20deep%20purple%20and%20black%20color%20palette%2C%20void%20like%20emptiness%2C%20fear%20inducing%20composition%2C%20clean%20simple%20horror%20style&width=600&height=800&seq=comic-cover-11&orientation=portrait',
    description: '在一座被浓雾包围的古老小镇上，居民们开始听到来自地底深处的低语声。没有人知道声音的来源，但每个听到低语的人都会在三天之内消失得无影无踪。记者崔敏宇为了调查姐姐的失踪来到这个小镇，却发现自己也陷入了这个无法挣脱的诅咒之中。深渊的秘密远比任何人想象的都要可怕，那些低语声——它们不是来自地底，而是来自你的内心深处。',
    category: '恐怖',
    categorySlug: 'horror',
    tags: ['恐怖', '超自然', '失踪', '诅咒'],
    status: '连载中',
    rating: 8.9,
    views: 3900000,
    favorites: 280000,
    chapters: [
      { id: 1101, title: '第38话 - 深渊之门', number: '38', updatedAt: '2026-08-04' },
      { id: 1102, title: '第37话 - 姐姐的日记', number: '37', updatedAt: '2026-07-28' },
      { id: 1103, title: '第36话 - 地下迷宫', number: '36', updatedAt: '2026-07-21' },
    ],
    updatedAt: '2026-08-04',
    createdAt: '2025-01-15',
    isHot: false,
    isNew: true,
    isCompleted: false,
  },
  {
    id: 12,
    title: '花与刀',
    author: 'Shin Yuna',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20BL%20romance%20Korean%20webtoon%20cover%20illustration%20of%20two%20elegant%20young%20men%20in%20traditional%20Korean%20scholar%20robes%2C%20one%20holding%20a%20flower%20the%20other%20a%20sword%2C%20soft%20romantic%20atmosphere%2C%20cherry%20blossom%20petals%2C%20historical%20Joseon%20era%20setting%2C%20gentle%20pastel%20colors%2C%20clean%20composition&width=600&height=800&seq=comic-cover-12&orientation=portrait',
    description: '朝鲜时代，天才剑客李韺与才华横溢的画家朴叙安在一次偶然的机会下相遇。一个是朝廷中最年轻的武官，一个是民间最受欢迎的画家，两个本应毫无交集的人却因为一幅神秘的画卷而被联系在了一起。在那个刀光剑影的时代，他们在彼此身上找到了前所未有的温暖与理解。这是一部画风精美、情感细腻的历史BL漫画，以其独特的国风美学和感人至深的故事赢得了众多读者的心。',
    category: 'BL',
    categorySlug: 'bl',
    tags: ['历史', '武侠', 'BL', '古风'],
    status: '连载中',
    rating: 9.4,
    views: 5500000,
    favorites: 380000,
    chapters: [
      { id: 1201, title: '第55话 - 花落无声', number: '55', updatedAt: '2026-08-03' },
      { id: 1202, title: '第54话 - 夜雨寄北', number: '54', updatedAt: '2026-07-27' },
      { id: 1203, title: '第53话 - 画中仙', number: '53', updatedAt: '2026-07-20' },
    ],
    updatedAt: '2026-08-03',
    createdAt: '2024-12-01',
    isHot: false,
    isNew: false,
    isCompleted: false,
  },
];

export const getComicsByCategory = (slug: string): Comic[] => {
  if (slug === 'all') return comics;
  return comics.filter((c) => c.categorySlug === slug);
};

export const getComicById = (id: number): Comic | undefined => {
  return comics.find((c) => c.id === id);
};

export const getHotComics = (): Comic[] => {
  return comics.filter((c) => c.isHot);
};

export const getNewComics = (): Comic[] => {
  return comics.filter((c) => c.isNew);
};

export const getCompletedComics = (): Comic[] => {
  return comics.filter((c) => c.isCompleted);
};

export const getPopularComics = (limit: number = 10): Comic[] => {
  return [...comics].sort((a, b) => b.views - a.views).slice(0, limit);
};

export const getLatestUpdates = (limit: number = 8): Comic[] => {
  return [...comics].sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()).slice(0, limit);
};

export const formatViews = (views: number): string => {
  if (views >= 10000000) return `${(views / 10000000).toFixed(1)}千万`;
  if (views >= 10000) return `${(views / 10000).toFixed(1)}万`;
  return views.toLocaleString();
};